"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startCallWith = exports.setInputDevicesError = exports.requestLocalStream = exports.receiveCall = exports.onPeerConnectionTrack = exports.onPeerConnectionStreamChange = exports.onPeerConnectionStream = exports.onPeerConnectionStats = exports.onPeerConnectionSignal = exports.onPeerConnectionIceStateChange = exports.onPeerConnectionIceError = exports.onPeerConnectionError = exports.onPeerConnectionData = exports.onPeerConnectionClose = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var onPeerConnectionError = payload => ({
  type: types.WRTC_ON_PC_ERROR,
  payload
});
exports.onPeerConnectionError = onPeerConnectionError;
var onPeerConnectionSignal = payload => ({
  type: types.WRTC_ON_PC_SIGNAL,
  payload
});
exports.onPeerConnectionSignal = onPeerConnectionSignal;
var onPeerConnectionStats = payload => ({
  type: types.WRTC_ON_PC_STATS,
  payload
});
exports.onPeerConnectionStats = onPeerConnectionStats;
var onPeerConnectionIceStateChange = payload => ({
  type: types.WRTC_ON_PC_ICE_STATE_CHANGE,
  payload
});
exports.onPeerConnectionIceStateChange = onPeerConnectionIceStateChange;
var onPeerConnectionIceError = payload => ({
  type: types.WRTC_ON_PC_ICE_ERROR,
  payload
});
exports.onPeerConnectionIceError = onPeerConnectionIceError;
var onPeerConnectionClose = payload => ({
  type: types.WRTC_ON_PC_CLOSE,
  payload
});
exports.onPeerConnectionClose = onPeerConnectionClose;
var onPeerConnectionTrack = payload => ({
  type: types.WRTC_ON_PC_TRACK_ADDED,
  payload
});
exports.onPeerConnectionTrack = onPeerConnectionTrack;
var onPeerConnectionData = payload => ({
  type: types.WRTC_ON_PC_DATA,
  payload
});
exports.onPeerConnectionData = onPeerConnectionData;
var onPeerConnectionStream = payload => ({
  type: types.WRTC_ON_PC_STREAM,
  payload
});
exports.onPeerConnectionStream = onPeerConnectionStream;
var onPeerConnectionStreamChange = payload => ({
  type: types.WRTC_ON_PC_STREAM_CHANGE,
  payload
});

// needs check in order to clear
exports.onPeerConnectionStreamChange = onPeerConnectionStreamChange;
var receiveCall = exports.receiveCall = function receiveCall(_target) {
  var haveFailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ROOM';
  var offer = arguments.length > 3 ? arguments[3] : undefined;
  return {
    type: types.WEBRTC_RECEIVE_CALL,
    _target,
    haveFailed,
    category,
    offer
  };
};
var requestLocalStream = (kind, params) => ({
  type: types.REQUEST_LOCAL_STREAM,
  kind,
  params
});
exports.requestLocalStream = requestLocalStream;
var setInputDevicesError = inputDevicesError => ({
  type: types.SET_INPUT_DEVICES_ERROR,
  inputDevicesError
});
exports.setInputDevicesError = setInputDevicesError;
var startCallWith = exports.startCallWith = function startCallWith(_target) {
  var haveFailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var category = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ROOM';
  var offer = arguments.length > 3 ? arguments[3] : undefined;
  return {
    type: types.START_CALL_WITH,
    _target,
    haveFailed,
    category,
    offer
  };
};